"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const base_1 = require("./base");
exports.default = new base_1.FlowNodeSpec({
    name: 'Data Record Deleted Trigger',
    description: 'Launch flow when a data record is deleted in a remote data collection',
    isTrigger: true,
});
//# sourceMappingURL=data-record-deleted-trigger.js.map